import { createFileRoute } from "@tanstack/react-router"

// Import the existing saved affiliates page
import AffiliateSaved from "@/features/jobs/affiliates/components/affiliate-saved-page"

export const Route = createFileRoute("/_screen/affiliate/saved")({
  component: AffiliateSavedPage
})

function AffiliateSavedPage() {
  return <AffiliateSaved />
}
